import Script from 'next/script';

export const GeniusMonkey = () => {
    return (
        <Script
            strategy="afterInteractive"
            src="https://pm.geniusmonkey.com/gm.js?id=1028352169&z=1"
            async
          />
    );
};
